import React from 'react';

export const renderButton = ({
  type = 'button',
  label,
  className = 'custom-btn',
  disabled = false,
  onClick,
  show = true,
  loading = false,
  loadingText = 'Please wait...',
}) => {
  if (!show) return null;

  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      className={`text-nowrap ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {loading ? (
        <div className="d-flex align-items-center gap-2">
          <span className="spinner-border spinner-border-sm" role="status" />
          <span>{loadingText}</span>
        </div>
      ) : (
        label
      )}
    </button>
  );
};
